var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-menu",
    {
      attrs: {
        "close-on-content-click": false,
        lazy: "",
        transition: "scale-transition",
        "offset-y": "",
        "full-width": "",
        "min-width": "290px",
      },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on }) {
            return [
              _c(
                "ControlTextField",
                _vm._g(
                  _vm._b(
                    {
                      attrs: {
                        "prepend-icon": "event",
                        label:
                          _vm.label +
                          ` (${_vm._getBrowserTimezone({ format: "long" })})`,
                        clearable: false,
                        readonly: "",
                      },
                      model: {
                        value: _vm.textValue,
                        callback: function ($$v) {
                          _vm.textValue = $$v
                        },
                        expression: "textValue",
                      },
                    },
                    "ControlTextField",
                    _vm.$attrs,
                    false
                  ),
                  on
                )
              ),
            ]
          },
        },
      ]),
      model: {
        value: _vm.menu,
        callback: function ($$v) {
          _vm.menu = $$v
        },
        expression: "menu",
      },
    },
    [
      _vm._v(" "),
      _c(
        "v-date-picker",
        _vm._g(
          {
            attrs: { value: _vm.value, min: _vm.min, max: _vm.max },
            on: { input: (val) => _vm.onInput(val) },
          },
          _vm.$listeners
        )
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }